<template>
  <a-tooltip>
    <template #title v-if="queueDeleted">
      <div>La cola seleccionada fue eliminada, recuerda reemplazarla para poder activar nuevamente tu secuencia.</div>
    </template>
    <div class="node" :class="{ selected: currentOpenNode === node.id }" @click="handleClick">
      <div class="content">
        <header class="margin-bottom">
          <div>
            <h2>
              <component :is="IconByType[node.type]" class="icon" />
              {{ " " }}
              <span class="node-name">{{ NodeTitleByType[node.type] }} </span>
              <span class="node-description">{{ node.title?.match(/\(([^)]+)\)/)?.[0] }}</span>
            </h2>
            <a-tag
              v-if="queueDeleted"
              color="warning"
            >
              <WarningFilled /> Cola eliminada
            </a-tag>
          </div>

          <p class="actions__detail margin-bottom">
            <!-- <InfoCircleOutlined v-if="node.action === ActionType.EndCall" /> -->
            {{ ActionNameByType[node.action] }}
          </p>
        </header>

        <div class="body">
          <p class="description">
            {{ getNodeDescription(node) }}
          </p>
          <div class="actions__button">
            <!-- <template v-if="node.type === NodeType.NumericDialing">
              <a-button
                type="link"
                class="button"
                :disabled="botDetails?.status === BotStatus.Active"
                @click.stop="handleAddOption"
              >
                Agregar opción
              </a-button>

              <a-divider type="vertical" class="divider" />
            </template> -->

            <!-- :disabled="sequence.status === SequenceStatus.Active || node.node_order > 1" // REVISAR con progresivo -->
            <a-button
              type="link"
              danger
              class="button"
              :disabled="sequence.status === SequenceStatus.Active"
              @click.stop="handleDelete"
            >
              Eliminar
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </a-tooltip>
</template>

<script setup lang="ts">
import { Ref, inject, computed, createVNode } from "vue";
import { Modal, message } from "ant-design-vue";

import { Sequence, SequenceNode, SequenceStatus } from "@/@types/flows/sequences";
import { IconByType } from "@/app/flows/sequences/utils/icons";
import {
  NodeTitleByType,
  ActionNameByType,
  getNodeDescription,
} from "@/app/flows/sequences/utils/texts";
import { ResponseError } from "@/app/shared/utils/httpManager";
import { sequenceNodeService } from "@/app/flows/sequences/services/SequenceNodes.service";
import { WarningFilled, QuestionCircleOutlined } from "@ant-design/icons-vue";

const props = defineProps<{
  node: SequenceNode;
  nodes: SequenceNode[];
  sequence: Sequence;
  parentNode: SequenceNode | undefined;
}>();

const emit = defineEmits<{
  click: [node: SequenceNode];
  delete: [ids: number[]];
  update: [];
}>();

const currentOpenNode = inject("currentOpenNode") as Ref<number | undefined>;

const handleClick = () => emit("click", props.node);

const handleDelete = async () => {
  Modal.confirm({
    icon: createVNode(QuestionCircleOutlined),
    centered: true,
    title: `¿Estás segur@ de eliminar esta acción de ${NodeTitleByType[props.node.type]}?`,
    content:
      "Recuerda que se eliminarán todas las acciones inferiores dependientes.",
    okText: "Eliminar",
    onOk: async () => {
      try {
        await sequenceNodeService.remove(props.node, props.nodes);

        const childNodes = (props.node.child || []).map((c) => c.id);

        emit("update");
        emit("delete", [props.node.id, ...childNodes]);
      } catch (error) {
        const errorMessage =
          error instanceof ResponseError ? error.getErrorMessage() : "Ha ocurrido un error";

        message.error(errorMessage);
        console.error(error);
      }
    }
  });
};

const queueDeleted = computed(() => {
  return props.node?.queue?.status == 3 && props.node?.queue?.total_users == 0;
});
</script>

<style scoped lang="sass">
h2, p
  margin: 0

.node
  border: 1px solid $gray-5
  border-radius: 8px
  padding: 12px
  width: 460px
  margin-bottom: 8px
  cursor: pointer

  &:hover
    border-color: $blue-6
    background-color: #E6F4FF

  &.selected
    border-color: $blue-6
    background-color: #E6F4FF

  &-name
    margin-right: 5px
  &-name:first-letter
    text-transform: uppercase

  &-description
    color: $gray-7
    font-weight: 400
    margin-right: 5px

.content
  width: 100%

h2
  color: $gray-9
  font-weight: 600
  font-size: 14px
  display: flex
  align-items: center
  line-height: 22px

  &.option-label
    color: $gray-8
    font-size: 12px

  .identifier
    font-size: 12px
    font-weight: 400
    color: $gray-7
    margin-left: 4px

header
  display: flex
  justify-content: space-between
  align-items: center
  margin-bottom: 4px
  div
    display: flex

.body
  color: $gray_dark_600
  display: flex
  justify-content: space-between
  align-items: center

  .description
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis

.button
  padding: 0
  height: 22px

.divider
  background-color: $gray-6

.actions
  &__detail
    color: $gray-7
    text-align: right
    font-style: italic

  &__button
    text-align: right
    flex: 0 0 auto

.flex-center
  display: flex
  align-items: center
  gap: 5px

.required-ivr-audio
  color: $gold-6

:deep(.icon)
  color: $blue-6
  font-weight: 600
  font-size: 18px
  margin-right: 10px
</style>
